<div class="content">


  <!-- <mat-drawer-container class="example-container" [hasBackdrop]="false" style="flex-flow: row wrap; flex-direction: row; box-sizing: border-box; display: flex; align-items: flex-start;"> -->
  <mat-drawer-container style="height: 100%;" class="clear-container">

    <!-- <mat-drawer style="height: 100%;" #drawer mode="side" position="start" opened="true">
      <div style="height: 100%; min-width: 250px; max-width: 250px; width: auto;" resizable r-directions="['left']" r-flex="false">
        <app-config-document-tree style="height: 100%;"></app-config-document-tree>
      </div>
    </mat-drawer> -->

    <mat-drawer-content>
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>

</div>